import './IncrementalityAgent.scss';
import { Tab, Tabs } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { MdOutlineScience } from 'react-icons/md';
import { AgentSessionManager } from '@Components/AgentChat';
import { useAppSelector } from '../../../redux';
import * as UserRedux from '../../../redux/user';
import { Agent, useAgentEndpoint, useIsDevelopmentAgent } from '../../../utils/agent-endpoints';
import v2ReleaseGuideMarkdown from './incrementality-agent-v2-release-guide.md?raw';

export const IncrementalityAgent = () => {
  const agentEndpoint = useAgentEndpoint(Agent.INCREMENTALITY);
  // CSV uploads are turned on in the agent's dev runtime only, so the attach button follows it
  // until the prod runtime accepts them too.
  const allowCsvAttachment = useIsDevelopmentAgent(Agent.INCREMENTALITY);
  return (
    <div className='inc-playbook-page incrementality-agent-page'>
      <Tabs defaultActiveKey='chat' className='incrementality-agent-tabs'>
        <Tab eventKey='chat' title='Chat'>
          <AgentSessionManager
            agentEndpoint={agentEndpoint}
            agent={Agent.INCREMENTALITY}
            // Incrementality is agent-agnostic (no real client company), but saveLLMMessage
            // requires a company to persist chat history — use the standard test company id.
            company='tinuititest'
            emptyState={<NewChatEmptyState />}
            allowCsvAttachment={allowCsvAttachment}
          />
        </Tab>
        <Tab eventKey='guide' title='V2 Release Guide'>
          <V2ReleaseGuide />
        </Tab>
      </Tabs>
    </div>
  );
};

const V2ReleaseGuide = () => (
  <div className='v2-release-guide'>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{v2ReleaseGuideMarkdown}</ReactMarkdown>
  </div>
);

const NewChatEmptyState = () => {
  const fullName = useAppSelector(UserRedux.fullNameSelector);
  const firstName = fullName?.split(/\s+/)[0] ?? '';

  return (
    <div className='new-chat'>
      <div className='new-chat-header'>
        <div className='new-chat-icon'>
          <MdOutlineScience />
        </div>
        {firstName && <h1 className='greeting'>Hey, {firstName}!</h1>}
        <h1 className='cta'>Let&apos;s measure incrementality!</h1>
      </div>
    </div>
  );
};
